/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { bool, string, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { actions as softTokenActions, selectors as softTokenSelectors } from "reducers/softToken";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import Credential from "pages/_components/fields/credentials/Credential";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const AddServiceConfirm = (props) => {
    const { isDesktop, fetching, deviceStatus, servicePaymentData } = props;
    const [requestBody, setRequestBody] = useState(false);
    const dispatch = useDispatch();

    const onBack = () => {
        dispatch(push("/addService"));
    };

    useEffect(() => {
        const params = {
            categoryName: servicePaymentData?.categoryName,  
            alias: servicePaymentData?.alias,
            entityName: servicePaymentData?.entityName,
            entityId: servicePaymentData?.entityId,  
            paymentCode: servicePaymentData?.paymentCode,  
            categoryId: servicePaymentData?.categoryId,
          };
        setRequestBody({
            params,
        });
    }, []);

    const hasAlias = () => servicePaymentData && servicePaymentData.alias;
    const className = hasAlias() ? "add-service-table-with-alias" : "add-service-table";
    return (
        <>
            <Notification scopeToShow="AddServiceConfirmPage" />
            <ResponsiveHeader
                id="services.payment.link.schedule.services.menu"
                defaultTitle="Adherir servicio"
                onClickBack={onBack}
            />
            <MainContainer className="discounts-echeq-review">
                <CustomText
                    text={i18n.get("vep.payment.data.review.title", "Confirmá la transacción")}
                    textType="TEXT"
                    className="discounts-echeq-review__date-control"
                    defa
                />
                <GridTable className={`${className} deposits-details-list`}>
                    <GridTable.Container columns={2} className="add-service-confirm-page-container">
                        <GridTable.Data columnStart={1} rowStart={1} className="confirm-text-padding">
                            <CustomData
                                titleText={i18n.get("services.payment.link.category.selector.label", "Rubro")}
                                titleClass="text-Primary-primary-color"
                                valueText={servicePaymentData?.categoryName}
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 2 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            className="confirm-text-padding">
                            <div>
                                <CustomData
                                    titleText={i18n.get("services.payment.link.entity.selector.label", "Empresa")}
                                    titleClass="text-Primary-primary-color"
                                    valueText={servicePaymentData?.entityName}
                                />
                            </div>
                        </GridTable.Data>
                        <GridTable.Data
                            // eslint-disable-next-line no-nested-ternary
                            rowStart={isDesktop ? (hasAlias() ? 2 : 1) : 3}
                            // eslint-disable-next-line no-nested-ternary
                            columnStart={isDesktop ? (hasAlias() ? 2 : 3) : 1}
                            className="confirm-text-padding">
                            <CustomData
                                titleText={i18n.get("services.payment.link.paymentCode.label", "Código de pago")}
                                titleClass="text-Primary-primary-color"
                                valueText={servicePaymentData?.paymentCode}
                            />
                        </GridTable.Data>
                        {hasAlias() && (
                            <GridTable.Data
                                columnStart={1}
                                rowStart={isDesktop ? 2 : 4}
                                className="confirm-text-padding">
                                <CustomData titleText={i18n.get("", "Alias")} valueText={servicePaymentData?.alias} />
                            </GridTable.Data>
                        )}
                    </GridTable.Container>
                </GridTable>

                <Formik
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                    >
                    {() => (
                        <>
                            <Row className="form-actions">
                                <GeneralCredentialForm
                                    transactionData={requestBody}
                                    type="otp"
                                    action={afipPaymentLinkActions.linkService}
                                    idActivity="link.service"
                                    hideIndications
                                />
                            </Row>
                            </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

AddServiceConfirm.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    servicePaymentData: shape({}).isRequired,
    fetching: bool.isRequired,
    // tokenInfo: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    // tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    fetching: afipPaymentLinkSelectors.getFetching(state),
    servicePaymentData: afipPaymentLinkSelectors.getServicesPaymentData(state),
    cuitIsAdhered: afipPaymentLinkSelectors.getCuitIsAdhered(state),
});
export default connect(mapStateToProps)(AddServiceConfirm);
